import api from './api';

export const groupBookingsService = {
  // Get all group bookings
  getAll: async () => {
    const response = await api.get('/group-bookings');
    return response.data;
  },

  // Get single group booking
  getById: async (id) => {
    const response = await api.get(`/group-bookings/${id}`);
    return response.data;
  },

  // Create group booking
  create: async (groupData) => {
    const response = await api.post('/group-bookings', groupData);
    return response.data;
  },

  // Update group booking
  update: async (id, groupData) => {
    const response = await api.put(`/group-bookings/${id}`, groupData);
    return response.data;
  },

  // Add participant
  addParticipant: async (groupId, participantData) => {
    const response = await api.post(`/group-bookings/${groupId}/participants`, participantData);
    return response.data;
  },

  // Get public booking page data
  getPublicBooking: async (publicUrl) => {
    const response = await api.get(`/group-bookings/public/${publicUrl}`);
    return response.data;
  }
};
